export const region = process.env.REGION
export const GOOGLE_MAPS_API_KEY = process.env.GOOGLE_MAPS_API_KEY
export const MAP_CENTER = {
  lat: -23.533773,
  lng: -46.62529,
}
export const TIMEZONE = 'America/Bahia'

export const googleMapsUrl = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`

export const COUNTRY_CODE = '+55'

export const typeformUrl = `//embed.typeform.com/next/embed.js`

export const whatsAppUrl = 'https://wa.me/'
